import { TableHead, TableRow, TableCell, TableBody, TextField, Table, InputAdornment } from "@mui/material";
import React from "react";
import { Range, RangeSetting } from "../../../types/QualityControlModels";

export const SampleSieveRangesTable = ({
    ranges,
    rangeSettings,
    isReady,
}: {
    ranges: Range[] | null | undefined;
    rangeSettings: RangeSetting[];
    isReady: boolean;
}) => {
    const showTable = isReady && !!ranges?.length && !!rangeSettings?.length;

    return showTable ? (
        <Table>
            <TableHead>
                <TableRow>
                    {rangeSettings.map((rangeSetting) => (
                        <TableCell key={rangeSetting.id}>{rangeSetting.name}</TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    {ranges.map((range: Range, index: number) => (
                        <TableCell key={index}>
                            <TextField
                                key={index}
                                value={range?.value || 0}
                                disabled
                                size="small"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                                sx={{
                                    // Make disabled input text darker
                                    "& .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled": {
                                        WebkitTextFillColor: "rgba(83, 83, 83, 1)", // Use primary text color
                                    },
                                }}
                            />
                        </TableCell>
                    ))}
                </TableRow>
            </TableBody>
        </Table>
    ) : (
        <>No Sieve Ranges to show</>
    );
};
